import { useState } from 'react';
import { SmartLink } from '../../fragments/smart-link/SmartLink';
import IconUI from '../../fragments/icon/IconUI';
import NavLevel3Menu from './NavLevel3Menu';

// Level 2 — a single link inside the dropdown panel. May open a Level 3 flyout.
export default function NavLevel2Link({ child, index }) {
  const hasChildren = child.children?.length > 0;

  // Open state drives the `.hover` class (which reveals the Level 3 flyout) and
  // `aria-expanded`. Kept as independent booleans so pointer and keyboard don't
  // fight each other: leaving with the mouse while focus is still inside (or
  // vice versa) keeps the flyout open.
  //
  // `toggled` is driven by an explicit click on the button. This is what makes
  // the control activatable for screen reader users: VoiceOver/NVDA activation
  // fires a click (not focus/hover), so without an onClick the button announced
  // its expanded state but could never actually open the flyout.
  const [hovered, setHovered] = useState(false);
  const [focused, setFocused] = useState(false);
  const [toggled, setToggled] = useState(false);
  const open = hovered || focused || toggled;

  const submenuId = `nav-submenu-${child.id}`;

  return (
    <li
      className={`NavLevel2Menu-item ${child.classes?.join(' ') || ''} ${
        hasChildren && open ? 'hover' : ''
      }`}
      onMouseEnter={hasChildren ? () => setHovered(true) : undefined}
      onMouseLeave={hasChildren ? () => setHovered(false) : undefined}
      onFocus={hasChildren ? () => setFocused(true) : undefined}
      onBlur={
        hasChildren
          ? (e) => {
              if (!e.currentTarget.contains(e.relatedTarget)) {
                setFocused(false);
                setToggled(false);
              }
            }
          : undefined
      }
    >
      {hasChildren ? (
        <button
          type="button"
          className="NavLevel2Menu-link headingStrong"
          aria-haspopup="true"
          aria-expanded={open}
          aria-controls={submenuId}
          onClick={() => setToggled((prev) => !prev)}
        >
          {child.label}
          <IconUI icon="chevronRight" />
        </button>
      ) : (
        <SmartLink href={child.uri} className="NavLevel2Menu-link headingStrong">
          {child.label}
          <IconUI icon="chevronRight" />
        </SmartLink>
      )}
      {hasChildren && (
        <NavLevel3Menu
          id={submenuId}
          children={child.children}
          uri={child.uri}
        />
      )}
    </li>
  );
}
